import React, { Component, createRef } from 'react';
//import moment from 'moment';
import './AdminPage.css';
import { Segment, Header, Form, Button, Label, Icon, Dropdown } from 'semantic-ui-react';

import Calendar from 'react-input-calendar';
import '../node_modules/react-input-calendar/style/index.css';

var moment = require('moment');

const errorInputStyle = { maxWidth: '25vw' };

class CreateInstructionPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            token: localStorage.token || '',
            client_1_title: '',
            client_1_firstname: '',
            client_1_middlenames: '',
            client_1_surname: '',
            client_1_dob: '',
            client_2_title: '',
            client_2_firstname: '',
            client_2_middlenames: '',
            client_2_surname: '',
            client_2_dob: '',
            address_1: '',
            address_2: '',
            address_town: '',
            address_postcode: '',
            client_phone: '',
            client_mobile: '',
            client_email: '',
            lender: '',
            selectedSource: 9082,
            sourceOptions: [{"key": 9082, "value": 9082, "text": "mobilesolicitors.co.uk"}],
            loadedSources: false,
            source: 'mobilesolicitors.co.uk',
            test: false,
            test_confirmEmail: '',
            submitting: false,
            submitResult: null,
            validationErrors: {}, // Separate state for validation errors
            errors: {
                contactDetails: null,
                client1Details: null,
                client2Details: null,
                addressDetails: null,
                otherDetails: null,
            },
            formSubmitted: false, // Add formSubmitted flag
            gpsCheckError: null, // Add state for GPS check error
            gpsCheckSuccess: false, // Add state for GPS check success
            gpsCheckLoading: false, // Add state for GPS check loading
            confirmationEmailRecipient: '@equilaw.uk.com', // Set default value for confirmation email
            middlewareEndpointURL: 'https://middleware.equilaw.uk.com', // Default middleware URL
        };
    
    this.onChange_client1dob = this.onChange_client1dob.bind(this);
    this.onChange_client2dob = this.onChange_client2dob.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSourceChange = this.handleSourceChange.bind(this);
    this.loadExistingSourceList_Wrapper = this.loadExistingSourceList_Wrapper.bind(this);
    this.loadExistingSourceList = this.loadExistingSourceList.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.loadExistingSourceList_Wrapper(this.state.middlewareEndpointURL);
    }
    // Handler for client 1 DOB calendar
    onChange_client1dob(value) {
        const formatted = moment(value).isValid() ? moment(value).format('DD/MMM/YYYY') : value;
        this.setState({ client_1_dob: formatted });
    }

    // Handler for client 2 DOB calendar
    onChange_client2dob(value) {
        const formatted = moment(value).isValid() ? moment(value).format('DD/MMM/YYYY') : value;
        this.setState({ client_2_dob: formatted });
    }

    handleChange = (e, { name, value, type, checked }) => {
        // Tightened phone validation
        if (name === 'client_phone') {
            // Clean pasted input: allow only digits and spaces
            let cleanedValue = value.replace(/[^0-9 ]/g, '');
            // Block any input beyond 15 characters (to allow formats like '01234 123 456')
            if (cleanedValue.length > 15) {
                return;
            }
            let valid = true;
            let phoneType = '';
            // Mobile: 07xxxxxxxxx, 11 digits, no spaces
            if (cleanedValue.startsWith('07')) {
                phoneType = 'mobile';
                valid = /^07\d{9}$/.test(cleanedValue.replace(/\s+/g, '')) && !cleanedValue.includes(' ');
            }
            // Landline: 01/02/03, 12 chars, allow with or without multiple spaces between area code and number
            else if (/^0[123]/.test(cleanedValue)) {
                phoneType = 'landline';
                // Accept with any number of spaces between area code and number
                // e.g. 01234567890, 01234 567890, 01234   567890
                valid = /^0[123]\d{9,10}$/.test(cleanedValue.replace(/\s+/g, '')) || /^0[123]\d{3,5}( +)\d{5,7}$/.test(cleanedValue);
            }
            else if (cleanedValue.length > 0) {
                valid = false;
            }
            this.setState(prevState => ({
                [name]: cleanedValue,
                validationErrors: {
                    ...prevState.validationErrors,
                    phone: cleanedValue && !valid
                }
            }));
            return;
        }

        // Ensure mobile field only accepts numeric input, first digit is 7, and max length is 10
        if (name === 'client_mobile' && value) {
            if (!/^[0-9]*$/.test(value)) {
                return; // Ignore non-numeric input
            }
            if (value.length > 0 && value[0] !== '7') {
                return; // Ignore if first digit is not 7
            }
            if (value.length > 10) {
                return; // Ignore if input exceeds 10 digits
            }
        }

        this.setState({
            [name]: type === 'checkbox' ? checked : value
        });

        // Ensure validation updates as email is typed
        if (name === 'client_email') {
            let clientEmailValid = true;
            if (value && value.trim() !== '') {
                clientEmailValid = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value);
            }
            this.setState(prevState => ({
                [name]: value,
                validationErrors: {
                    ...prevState.validationErrors,
                    client_email: value && value.trim() !== '' ? !clientEmailValid : false,
                    contact: !([
                        prevState.client_phone,
                        prevState.client_mobile,
                        value // client_email field
                    ].some(val => val && val.trim() !== ''))
                }
            }));
            return;
        }
        // Live validation for confirmation email
        if (name === 'confirmationEmailRecipient') {
            const confirmationEmailValid = value && /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value);
            this.setState(prevState => ({
                [name]: value,
                validationErrors: {
                    ...prevState.validationErrors,
                    confirmationEmailRecipient: !confirmationEmailValid
                }
            }));
            return;
        }
    }

    handleSubmit = async (e, url) => {
    e.preventDefault();
    console.log('handleSubmit called');

        // Validation logic
        let hasErrors_client1 = false;
        let hasErrors_contact = false;
    // Remove duplicate declaration; will be set below if needed
        let hasErrors_address = false;
        let hasErrors_other = false;

        // Validate client 1 details
        const requiredClient1Fields = ['client_1_firstname', 'client_1_surname'];
        hasErrors_client1 = requiredClient1Fields.some(field => !this.state[field] || this.state[field].trim() === '');

        // Validate contact details
        let clientEmailValid = true;
        if (this.state.client_email && this.state.client_email.trim() !== '') {
            clientEmailValid = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.state.client_email);
        }
        const phoneDigits = this.state.client_phone ? this.state.client_phone.replace(/\s+/g, '') : '';
        const ukPhoneRegex = /^(07\d{9}|0[123]\d{8,9})$/;
        const phoneValid = this.state.client_phone ? ukPhoneRegex.test(phoneDigits) : true;
        const isContactProvided = [
            this.state.client_phone,
            this.state.client_mobile,
            this.state.client_email
        ].some(val => val && val.trim() !== '');
        hasErrors_contact = !isContactProvided;

        // Validate other sections
        const requiredAddressFields = ['address_1', 'address_postcode'];
        hasErrors_address = requiredAddressFields.some(field => !this.state[field] || this.state[field].trim() === '');

    // No validation for Client 2 fields except DOB (handled below)
    let hasErrors_client2 = false;

        const requiredOtherFields = ['source'];
        hasErrors_other = requiredOtherFields.some(field => !this.state[field] || this.state[field].trim() === '');

        // Validate confirmation email format
    const confirmationEmailValid = this.state.confirmationEmailRecipient && /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.state.confirmationEmailRecipient);

        // Collect all errors
        const validationErrors = {
            client_email: !clientEmailValid,
            confirmationEmailRecipient: !confirmationEmailValid,
            contact: !isContactProvided,
            client1: hasErrors_client1,
            client2: hasErrors_client2,
            address: hasErrors_address,
            other: hasErrors_other,
            phone: this.state.client_phone ? !phoneValid : false // show error if phone is present and invalid
        };

        var hasErrors = Object.values(validationErrors).some(Boolean);

        // Update all validation state at once
        this.setState({
            formSubmitted: true,
            validationErrors,
            submitting: false
        }, () => {
            console.log('Validation State:', {
                clientEmailValid,
                isContactProvided,
                validationErrors: this.state.validationErrors,
                formSubmitted: this.state.formSubmitted
            });
        });
        //
        hasErrors = Object.values(validationErrors).some(Boolean);
        //
        console.log('Has Errors:', hasErrors);
        if (hasErrors) {
            return;
        }

        this.setState({ submitting: true, submitResult: null });
        const data = { ...this.state };
        // Prepend '+44' to client_mobile if not empty and doesn't already start with '+44'
        if (data.client_mobile && !data.client_mobile.startsWith('+44')) {
            data.client_mobile = '+44' + data.client_mobile;
        }
        // Remove all whitespace from client_phone before submitting
        if (data.client_phone) {
            data.client_phone = data.client_phone.replace(/\s+/g, '');
        }
        // Remove UI-only state
        delete data.submitting;
        delete data.submitResult;
        delete data.formSubmitted; // Remove formSubmitted from submission payload
        delete data.validationErrors; // Remove validationErrors from submission payload

        // Remove DOBs if more recent than 18 years ago
        const eighteenYearsAgo = moment().subtract(18, 'years');
        //
        if (data.client_1_dob && moment(data.client_1_dob, 'DD/MMM/YYYY').isAfter(eighteenYearsAgo)) {
            console.log('client_1_dob removed from POST: too recent');
            delete data.client_1_dob;
        }
        if (data.client_2_dob && moment(data.client_2_dob, 'DD/MMM/YYYY').isAfter(eighteenYearsAgo)) {
            console.log('client_2_dob removed from POST: too recent');
            delete data.client_2_dob;
        }
        // Debug: log the payload before POST
        console.log('POST payload:', data);

        try {
            const response = await fetch(url + '/DPS/Instruction', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            });
            let result;
            if (response.status === 400) {
                // If 400, get text and show as error
                const errorText = await response.text();
                result = { error: errorText };
            } else {
                result = await response.json();
            }
            this.setState({ submitResult: result, submitting: false });
        } catch (error) {
            this.setState({ submitResult: { error: error.message }, submitting: false });
        }
    }

    handleGPSCheck = async (e, url) => {
        e.preventDefault();
        if (this.state.address_postcode) {
            this.setState({ gpsCheckLoading: true, gpsCheckSuccess: false });
            try {
                const response = await fetch(url + '/Middleware/PostcodeGPSCheck', {
                    method: 'POST',
                    headers: { 
                        'Accept': 'application/json',
                        'Content-Type': 'application/json' 
                    },
                    body: JSON.stringify({
                        token: localStorage.getItem('token'),
                        postcode: this.state.address_postcode
                    })
                });
                const result = await response.json();
                console.log('GPS Check result:', result);
                if (result && result.result === false) {
                    this.setState({ gpsCheckError: result.message, gpsCheckSuccess: false, gpsCheckLoading: false });
                } else if (result && result.result === true) {
                    this.setState({ gpsCheckError: null, gpsCheckSuccess: true, gpsCheckLoading: false });
                } else {
                    this.setState({ gpsCheckError: null, gpsCheckSuccess: false, gpsCheckLoading: false });
                }
            } catch (error) {
                console.error('GPS Check error:', error);
                this.setState({ gpsCheckError: 'GPS Check failed. Please try again.', gpsCheckSuccess: false, gpsCheckLoading: false });
            }
        }
    }

    loadExistingSourceList_Wrapper(url) {
        var result = this.loadExistingSourceList(url);
        result.then((data) => {
            switch (data.httpCode) {
                case 200:
                    var options = data.body;
                    options = options.filter(option => option.value !== 9496); // Remove mobilesolcitors.co.uk //NOTE THE SPELLING MISTAKE
                    this.setState({
                        sourceOptions: options,
                        loadedSources: true,
                    });
                    break;
                case 400:
                    break;
                default:
                    break;
            }
        });
    }
    //
    async loadExistingSourceList(url) {
        const response = await fetch(url + "/Middleware/GetListOfAllSources", {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                token: localStorage.token
            })
        });
        const responseObject = {
            httpCode: response.status,
            body: response.status === 200 || response.status === 400 ? await response.json() : ""
        }
        return responseObject;
    }

    // Handler for source dropdown change
    handleSourceChange = (event, data) => {
        var sourceName = '';
        for (const [key, value] of Object.entries(data)) {
            sourceName = this.state.sourceOptions.find(option => option.value === data.value)?.text || '';
        }
        this.setState({
            selectedSource: data.value,
            source: sourceName
        });
        console.log(data);
        console.log("Source Id: " + data.value + ", Source Text: " + sourceName);
    }

    render() {
        const today = moment().format('DD/MMM/YYYY');
        const isContactProvided = ['client_phone', 'client_mobile', 'client_email'].some(
            field => this.state[field] && this.state[field].trim() !== ''
        );
        const hasErrors_contact = this.state.formSubmitted && !['client_phone', 'client_mobile', 'client_email'].some(
            field => this.state[field] && this.state[field].trim() !== ''
        );
        return (
            <Segment>
                <Label className="Matters-Header-Segment" attached="top">
                    <h3 className="Matters-Header">
                        <Icon className="edit icon big" />&emsp;Create Instruction
                    </h3>
                </Label>
                <br /><br /><br />
                <Form>
                    <Form.Field>
                        <Header as="h4">Client 1</Header>
                        <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
                            <Form.Input name="client_1_title" label="Title" placeholder="Title" value={this.state.client_1_title} onChange={this.handleChange} style={{ maxWidth: '25vw' }} />
                        </div>
                        <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
                            <Form.Input
                                name="client_1_firstname"
                                label="First Name"
                                placeholder="First Name"
                                value={this.state.client_1_firstname}
                                onChange={this.handleChange}
                                required
                                style={errorInputStyle}
                                error={this.state.formSubmitted && !this.state.client_1_firstname}
                            />
                            {this.state.formSubmitted && !this.state.client_1_firstname && (
                                <Label basic color="red" pointing>
                                    First Name is required
                                </Label>
                            )}
                        </div>
                        <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
                            <Form.Input name="client_1_middlenames" label="Middle Names" placeholder="Middle Names" value={this.state.client_1_middlenames} onChange={this.handleChange} style={{ maxWidth: '25vw' }} />
                        </div>
                        <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
                            <Form.Input
                                name="client_1_surname"
                                label="Surname"
                                placeholder="Surname"
                                value={this.state.client_1_surname}
                                onChange={this.handleChange}
                                required
                                style={errorInputStyle}
                                error={this.state.formSubmitted && !this.state.client_1_surname}
                            />
                            {this.state.formSubmitted && !this.state.client_1_surname && (
                                <Label basic color="red" pointing>
                                    Surname is required
                                </Label>
                            )}
                        </div>
                        <div style={{ margin: '10px 0' }}>
                            <label style={{ display: 'block', paddingBottom: '16px' }}><b>Client 1 Date of Birth</b></label>
                            <Calendar
                                id="calendar_client_1_dob"
                                format="DD/MMM/YYYY"
                                displayYrWithMonth={true}
                                closeOnSelect={true}
                                openOnInputFocus={true}
                                openOnInputClick={true}
                                date={this.state.client_1_dob}
                                onChange={this.onChange_client1dob}
                                inputFieldClass="input-calendar-value IQ-Calendar"
                                maxDate={today}
                                locale="en-gb"
                                //inputProps={{ readOnly: true }}
                            />
                            {/* Client 1 DOB error message */}
                            {this.state.client_1_dob && moment(this.state.client_1_dob, 'DD/MMM/YYYY').isAfter(moment().subtract(18, 'years')) && (
                                <span style={{ color: 'red', marginLeft: '12px', fontWeight: 'bold' }}>
                                    DOB too recent, it will be ignored
                                </span>
                            )}
                        </div>
                    </Form.Field>
                    <hr />
                    <Form.Field>
                        <Header as="h4">Client 2</Header>
                        <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
                            <Form.Input name="client_2_title" label="Title" placeholder="Title" value={this.state.client_2_title} onChange={this.handleChange} style={{ maxWidth: '25vw' }} />
                        </div>
                        <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
                            <Form.Input name="client_2_firstname" label="First Name" placeholder="First Name" value={this.state.client_2_firstname} onChange={this.handleChange} style={{ maxWidth: '25vw' }} />
                        </div>
                        <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
                            <Form.Input name="client_2_middlenames" label="Middle Names" placeholder="Middle Names" value={this.state.client_2_middlenames} onChange={this.handleChange} style={{ maxWidth: '25vw' }} />
                        </div>
                        <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
                            <Form.Input name="client_2_surname" label="Surname" placeholder="Surname" value={this.state.client_2_surname} onChange={this.handleChange} style={{ maxWidth: '25vw' }} />
                        </div>
                        <div style={{ margin: '10px 0' }}>
                            <label style={{ display: 'block', paddingBottom: '16px' }}><b>Client 2 Date of Birth</b></label>
                            <Calendar
                                id="calendar_client_2_dob"
                                format="DD/MMM/YYYY"
                                displayYrWithMonth={true}
                                closeOnSelect={true}
                                openOnInputFocus={true}
                                openOnInputClick={true}
                                date={this.state.client_2_dob}
                                onChange={this.onChange_client2dob}
                                inputFieldClass="input-calendar-value IQ-Calendar"
                                maxDate={today}
                                locale="en-gb"
                                inputProps={{ readOnly: true }}
                            />
                            {/* Client 2 DOB error message */}
                            {this.state.client_2_dob && moment(this.state.client_2_dob, 'DD/MMM/YYYY').isAfter(moment().subtract(18, 'years')) && (
                                <span style={{ color: 'red', marginLeft: '12px', fontWeight: 'bold' }}>
                                    DOB too recent, it will be ignored
                                </span>
                            )}
                        </div>
                    </Form.Field>
                    <hr />
                    <Form.Field>
                        <Header as="h4">Address</Header>
                        <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
                            <Form.Input
                                name="address_1"
                                label="Address 1"
                                placeholder="Address 1"
                                value={this.state.address_1}
                                onChange={this.handleChange}
                                style={errorInputStyle}
                                required
                                error={this.state.formSubmitted && !this.state.address_1}
                            />
                            {this.state.formSubmitted && !this.state.address_1 && (
                                <Label basic color="red" pointing>
                                    Address 1 is required
                                </Label>
                            )}
                        </div>
                        <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
                            <Form.Input name="address_2" label="Address 2" placeholder="Address 2" value={this.state.address_2} onChange={this.handleChange} style={{ maxWidth: '25vw' }} />
                        </div>
                        <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
                            <Form.Input name="address_town" label="Town" placeholder="Town" value={this.state.address_town} onChange={this.handleChange} style={{ maxWidth: '25vw' }} />
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                            <Form.Input
                                name="address_postcode"
                                label="Postcode"
                                placeholder="Postcode"
                                value={this.state.address_postcode}
                                onChange={this.handleChange}
                                style={errorInputStyle}
                                required
                                error={this.state.formSubmitted && !this.state.address_postcode}
                            />
                            <Button
                                color="green"
                                onClick={(e) => this.handleGPSCheck(e, this.state.middlewareEndpointURL)}
                                style={{ minWidth: '100px', height: '38px', marginTop: '9px' }}
                                disabled={this.state.gpsCheckLoading}
                            >
                                {this.state.gpsCheckLoading ? (
                                    <Icon name="spinner" loading />
                                ) : (
                                    'GPS Check'
                                )}
                            </Button>
                            {this.state.gpsCheckError && (
                                <span style={{ color: 'red', marginLeft: '12px', marginTop: '15px', fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>
                                    <Icon name="times circle" color="red" style={{ marginRight: '6px', marginTop: '-6px' }} />
                                    {this.state.gpsCheckError}
                                </span>
                            )}
                            {this.state.gpsCheckSuccess && !this.state.gpsCheckError && (
                                <Icon name="check circle" color="green" style={{ marginLeft: '12px' }} />
                            )}
                        </div>
                        {this.state.formSubmitted && !this.state.address_postcode && (
                            <Label basic color="red" pointing>
                                Postcode is required
                            </Label>
                        )}
                    </Form.Field>
                    <hr />
                    <Form.Field>
                        <Header as="h4">Contact</Header>
                        {this.state.formSubmitted && this.state.validationErrors.contact && !this.state.client_phone && !this.state.client_email && !this.state.client_mobile && (
                            <Label basic color="red" style={{ marginBottom: '10px' }}>
                                At least one contact field (Phone, Mobile, or Email) must be filled.
                            </Label>
                        )}
                        <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
                            <Form.Input 
                                name="client_phone"
                                label="Phone"
                                placeholder="Phone"
                                value={this.state.client_phone}
                                onChange={this.handleChange}
                                style={this.state.formSubmitted && this.state.client_phone && this.state.validationErrors.phone ? { ...errorInputStyle, borderColor: 'red' } : errorInputStyle}
                                error={Boolean(this.state.formSubmitted && this.state.client_phone && this.state.validationErrors.phone)}
                            />
                            {(this.state.formSubmitted && this.state.client_phone && this.state.validationErrors.phone) ? (
                                <Label basic color="red" pointing>
                                    Please enter a valid UK phone number.
                                </Label>
                            ) : null}
                        </div>
                        <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
                            <Form.Input 
                                name="client_mobile" 
                                label="Mobile" 
                                placeholder="Mobile" 
                                value={this.state.client_mobile} 
                                onChange={this.handleChange} 
                                style={this.state.formSubmitted && this.state.client_mobile && this.state.validationErrors.mobile ? { ...errorInputStyle, borderColor: 'red' } : errorInputStyle}
                                error={Boolean(this.state.formSubmitted && this.state.client_mobile && this.state.validationErrors.mobile)}
                                iconPosition="left"
                            >
                                <Label basic style={{ marginRight: '8px', display: 'flex', alignItems: 'center' }}>+44</Label>
                                <input style={{ marginLeft: '0', paddingLeft: '0' }} />
                            </Form.Input>
                            {(this.state.formSubmitted && this.state.client_mobile && this.state.validationErrors.mobile) ? (
                                <Label basic color="red" pointing>
                                    Please enter a valid UK mobile number.
                                </Label>
                            ) : null}
                        </div>
                        <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
                            <Form.Input 
                                name="client_email" 
                                label="Email" 
                                placeholder="Email" 
                                value={this.state.client_email} 
                                onChange={this.handleChange} 
                                style={this.state.formSubmitted && this.state.client_email && this.state.validationErrors.client_email ? { ...errorInputStyle, borderColor: 'red' } : errorInputStyle}
                                error={Boolean(this.state.formSubmitted && this.state.client_email && this.state.validationErrors.client_email)}
                            />
                            {(this.state.formSubmitted && this.state.client_email && this.state.validationErrors.client_email) ? (
                                <Label basic color="red" pointing>
                                    Please enter a valid email address.
                                </Label>
                            ) : null}
                        </div>
                    </Form.Field>
                    <hr />
                    <Form.Field>
                        <Header as="h4">Other Details</Header>
                        {/* <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
                            <Form.Input name="lender" label="Lender (Optional)" placeholder="Lender" value={this.state.lender} onChange={this.handleChange} style={{ maxWidth: '25vw' }} />
                        </div> */}
                        <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
                            <label>Source</label>
                            <Dropdown
                                fluid
                                selection
                                search
                                placeholder="Select Source..."
                                value={this.state.selectedSource}
                                options={this.state.sourceOptions}
                                onChange={this.handleSourceChange}
                                style={errorInputStyle}
                            />
                        </div>
                        <Form.Checkbox name="test" label="Is this a Test case?" checked={this.state.test} onChange={this.handleChange} style={{ maxWidth: '25vw', paddingTop: '8px', paddingBottom: '8px' }} />
                        <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
                            <Form.Input 
                                name="confirmationEmailRecipient" 
                                label="Confirmation Email (You will receive an email with the case reference)" 
                                placeholder="Confirmation Email" 
                                value={this.state.confirmationEmailRecipient} 
                                onChange={this.handleChange} 
                                style={this.state.formSubmitted && this.state.confirmationEmailRecipient && this.state.validationErrors.confirmationEmailRecipient ? { ...errorInputStyle, borderColor: 'red' } : errorInputStyle} 
                                error={this.state.formSubmitted && this.state.confirmationEmailRecipient && this.state.validationErrors.confirmationEmailRecipient}
                            />
                            {this.state.formSubmitted && this.state.confirmationEmailRecipient && this.state.validationErrors.confirmationEmailRecipient && (
                                <Label basic color="red" pointing>
                                    Please enter a valid confirmation email address.
                                </Label>
                            )}
                        </div>
                    </Form.Field>
                    <Button 
                        type="submit" 
                        primary 
                        style={{ maxWidth: '25vw', marginTop: '20px' }} 
                        onClick={(e) => this.handleSubmit(e, this.state.middlewareEndpointURL)} 
                        disabled={this.state.submitting || (this.state.submitResult && !this.state.submitResult.error)}
                        loading={this.state.submitting && !(this.state.submitResult && !this.state.submitResult.error)}
                    >
                        Submit
                    </Button>
                    {this.state.submitResult && this.state.submitResult.error && !this.state.validationErrors?.contact && (
                        <div style={{ marginTop: '20px', color: 'red' }}>
                            {typeof this.state.submitResult.error === 'string'
                                ? this.state.submitResult.error
                                : `Error: ${this.state.submitResult.error}`}
                        </div>
                    )}
                    {this.state.submitResult && !this.state.submitResult.error && this.state.validationErrors?.contact === false && (
                        <div style={{ marginTop: '20px', color: 'green' }}>
                            Success! Instruction created. Reference: {this.state.submitResult.matterRef}
                        </div>
                    )}
                </Form>
            </Segment>
        );
    }
}

export default CreateInstructionPage;
